<!--
 * @Author: 
 * @LastEditTime: 2024-04-26 18:37:43
 * @Description: 
-->
<template>
  <div class="h-full w-full relative">
    <div class="w-full h-28/100 overflow-y-auto">
      <div
        class="w-full flex justify-start items-center mt-20px py-16px px-10px person-bg"
      >
        <div class="mr-16px">
          <img
            class="w-26 h-26 mx-auto mr-10px"
            src="../../../assets/images/personPosition/avatar.jpg"
            alt=""
          />
        </div>
        <div>
          <p class="text-white mb-2.5 text-14px">
            <span class="text-hex-85c6cb">姓名&nbsp;&nbsp;</span> {{ person.name }}
          </p>
          <p class="text-white mb-2.5 text-14px">
            <span class="text-hex-85c6cb">身份&nbsp;&nbsp;</span> {{ person.position }}
          </p>
          <p class="text-white mb-2.5 text-14px">
            <span class="text-hex-85c6cb">部门&nbsp;&nbsp;</span> {{ person.department }}
          </p>
          <p class="text-white mb-2.5 text-14px">
            <span class="text-hex-85c6cb">岗位&nbsp;&nbsp;</span> {{ person.email }}
          </p>
          <p class="text-white text-14px">
            <span class="text-hex-85c6cb">年龄&nbsp;&nbsp;</span> {{ person.phone }}
          </p>
        </div>
      </div>
    </div>
    <div class="w-full h-20/100 pl-10px">
      <div>
        <p class="text-white mb-2.5 text-14px">
          <span class="text-hex-85c6cb">工作单位&nbsp;&nbsp;</span> {{ person.name }}
        </p>
        <p class="text-white mb-2.5 text-14px">
          <span class="text-hex-85c6cb">手机号码&nbsp;&nbsp;</span> {{ person.position }}
        </p>
        <p class="text-white mb-2.5 text-14px">
          <span class="text-hex-85c6cb">身份证号&nbsp;&nbsp;</span> {{ person.department }}
        </p>
      </div>
      <div class="flex justify-start items-center mt-30px">
        <el-button size="primary" class="mr-10px" @click="searcheTrajectory()">轨迹查询</el-button>
        <el-button size="primary" class="mr-10px" @click="visibleLabel = '附近的人'"
          >附近的人</el-button
        >
      </div>
    </div>
    <div class="w-full h-48/100">
      <div class="h-full w-full" v-if="visibleLabel === '附近的人'">
        <el-table
          :data="tableData"
          highlight-current-row
          class="!h-full !w-full"
          ref="tableRef"
          v-loading="tableLoading"
        >
          <el-table-column label="姓名" prop="name" show-overflow-tooltip></el-table-column>
          <el-table-column
            label="所属部门"
            prop="department"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="距离" prop="distance" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="{ row }">
              <div class="cursor-pointer text-hex-00bcc8">
                查看
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          small
          background
          @size-change="getTableData()"
          @current-change="getTableData()"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          :pager-count="5"
          layout="slot, prev, pager, next"
          :total="page.total"
          class="text-center"
        >
          <template>
            <div class="inline-block h-24px leading-24px text-15px">
              共
              <span class="!leading-22px text-center text-hex-fbaf3d">{{ page.total }}</span
              >条数据
            </div>
          </template>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import CardTitle from '@/components/cockpit/CardTitle'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
export default {
  name: 'TsgPersonPosition',
  components: {
    CardTitle,
    CategoryTitle,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      person: {
        name: 'John Doe',
        avatar: '',
        position: 'CEO',
        department: 'Marketing',
        email: 'john@example.com',
        phone: '123-456-7890',
      },
      tableData: [
        {
          name: 'John Doe',
          department: 'Marketing',
          distance: '100m',
        },
        {
          name: 'Jane Doe',
          department: 'Sales',
          distance: '50m',
        },
        {
          name: 'Tom Smith',
          department: 'Finance',
          distance: '20m',
        },
      ],
      tableLoading: false,
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 3,
      },
      visibleLabel: '附近的人',
      currentBtn: '',
      isFollow: false,
    }
  },
  watch: {
    currentBtn(value) {
      if (value === 'trajectory') {
        // 打开历史轨迹的弹框
        this.$emit('operateTrajectory', {
          visible: true,
          personnelId: '',
          tagCode: '',
        })
      }
    },
  },
  computed: {
    tagCode() {
      return this.transferProps.tagCode
    },
  },
  methods: {
    markerClick(e) {
      // 左键点击并且有id
      if (e.type === 1 && !isEmpty(e.id)) {
        if (this.tagCode === e.id) {
          this.currentBtn = 'locationTracking'
          this.isFollow = true
        }
      }
    },
    // 点击轨迹查询按钮
    async searcheTrajectory() {
      this.currentBtn = 'trajectory'
      this.visibleLabel = '轨迹查询'
      if (this.isFollow) {
        this.isFollow = false
        // 取消跟随
        await this.cloudRender.PosViewer.cancelPerspectiveFollow()
      }
    },
    // 获取附近的人列表数据
    getTableData() {
      this.tableLoading = true
      setTimeout(() => {
        this.tableData = [
          {
            name: 'John Doe',
            department: 'Marketing',
            distance: '100m',
          },
          {
            name: 'Jane Doe',
            department: 'Sales',
            distance: '50m',
          },
          {
            name: 'Tom Smith',
            department: 'Finance',
            distance: '20m',
          },
        ]
        this.tableLoading = false
      }, 1000)
    },
  },
  async created() {},
  mounted() {
    this.cloudRender.Dispatch.on('PosViewerMarker', this.markerClick)
  },
  beforeDestroy() {
    // 解绑事件
    this.cloudRender.Dispatch.off('PosViewerMarker', this.markerClick)
    if (this.isFollow) {
      // 取消跟随
      this.cloudRender.PosViewer.cancelPerspectiveFollow()
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-button {
  color: #fff;
  font-size: 14px;
  height: 38px;
  border: none;
  background-color: transparent;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url('~@/assets/images/cockpit/cyan/commonButton.png') !important;

  &.active {
    background-image: url('~@/assets/images/cockpit/cyan/commonButtonActive.png') !important;
  }

  &.round {
    border-radius: 20px;
  }

  &:hover,
  &:focus {
    background-image: url('~@/assets/images/cockpit/cyan/commonButtonActive.png') !important;
  }
}
.person-bg {
  // background-size: 100% 100%;
  // background-repeat: no-repeat;
  // background-position: center;
  // background-image: url('../../../assets/images/personPosition/person_bg.png') !important;
  background: linear-gradient(90deg, #27c6c63f 0%, #05b7d326 100%);
  opacity: 0.9;
  border: 1px solid #44f1ff;
}
</style>
